import AppLayout from "../components/layout/AppLayout";
import SettingsComponent from "../components/settings/SettingsComponent";

export default function Settings() {
  return (
    <AppLayout>
      <SettingsComponent />
    </AppLayout>
  );
}
